import { StyleSheet } from 'aphrodite';
import { success } from '../../../../web/styles/colors';
import { ctaButtonProps } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		height: '100%',
		padding: '0 20px',
		position: 'relative',
		width: '100%',
	},
	editor: {
		boxSizing: 'border-box',
		height: '100%',
		paddingTop: 26,
		width: '100%',
	},
	publishButton: {
		...ctaButtonProps(success),
	},
});
